import MainImage from '../voluntary-template/icons/Ecology.png';
import VectorFirst from '../voluntary-template/icons/box/shield.svg';
import VectirSecond from '../voluntary-template/icons/box/list.svg';
import VectorThird from '../voluntary-template/icons/box/info.svg';
import Checkbox from '../voluntary-template/icons/Checkbox.svg';
import Thunder from '../voluntary-template/icons/Thunder.svg';
import Contract from '../voluntary-template/icons/Eco.png';
import Shield from '../voluntary-template/icons/Shield.png';
import Star from '../voluntary-template/icons/Star.png';
import Pyramid from '../voluntary-template/icons/pyramid.png';
import People from '../voluntary-template/icons/people.png';
import Box from '../voluntary-template/icons/Box.png';

const ecologyResources = {
  en: {
    ecology: {
      title: 'Mandatory Environmental Insurance',
      description:
        'Mandatory liability insurance for environmental damage. The policy covers risks of air, water, and soil pollution, as well as expenses for eliminating environmental harm.',
      buttonText: 'Submit Application',
      infoCards: [
        {
          title: 'Legal Compliance',
          content:
            'The policy is stipulated by the Environmental Code of the Republic of Kazakhstan.',
        },
        {
          title: 'Coverage of Environmental Risks',
          content:
            'Pollution, leaks, accidents — insurance helps compensate for the damage.',
        },
        {
          title: 'For All Enterprises',
          content:
            'Including industrial, agricultural, and transportation organizations.',
        },
      ],
      coverage: [
        {
          title: 'What Is Insured',
          content: ['Liability for damage caused to the environment'],
        },
        {
          title: 'Covered Risks',
          content: [
            'Pollution of air, water, and soil',
            'Leakage of hazardous substances',
            'Environmental accidents',
            'Costs of damage elimination',
          ],
        },
        {
          title: 'Illustration',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Insurance Amount',
          content:
            'Determined individually, based on the risk category and type of activity.',
        },
        {
          title: 'Policy Duration',
          content: '1 year. Extended for the duration of permits and licenses.',
        },
        {
          title: 'Territory of Coverage',
          content: 'Republic of Kazakhstan.',
        },
      ],
      formTitle: 'Insurance Application',
      formDescription:
        'Please be sure to provide the company name, BIN, and contact phone number.',
      formCheckBox1: 'I confirm',
      formCheckBox2:
        'my consent to the collection and processing of personal data',
      formPlaceholder1: 'Company',
      formPlaceholder2: 'BIN',
      formPlaceholder3: 'Full Name',
      formPlaceholder4: 'Phone',
      formPlaceholder5: 'Email',
      formPlaceholder6: 'Comment',
      formButtonText: 'Submit Application',
      formSuccessStatus: 'Your application has been submitted successfully.',
      formErrorStatus: 'Failed to submit the application.',
      formErrorMessage:
        'Please try submitting the application again in 4 hours.',
      formSendClose: 'Close',
      trustTitle: 'Why clients trust Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 years',
            content: 'on the insurance market of Kazakhstan',
          },
          {
            id: 2,
            title: 'TOP 2',
            content: 'by volume of insurance payouts',
          },
          {
            id: 3,
            title: 'kzA-',
            content: 'financial stability rating by S&P Global Ratings',
          },
          {
            id: 4,
            title: '600+',
            content: 'employees working across the country',
          },
        ],
        second: [
          {
            id: 5,
            title: '₸59.4 billion',
            content: 'insurance premiums collected in 2024',
          },
          {
            id: 6,
            title: '₸22 billion',
            content: 'insurance payouts made in 2024',
          },
        ],
        third: '(According to the National Bank of Kazakhstan, Jan–Feb 2025)',
      },
    },
  },
  kz: {
    ecology: {
      title: 'Міндетті экологиялық сақтандыру',
      description:
        'Авария нәтижесінде экологиялық залал келтіру салдарынан туындайтын міндеттемелер бойынша азаматтық-құқықтық жауапкершілік туындаған кезде жеке және (немесе) заңды тұлғалардың (сақтандырылушылардың) заңды мүдделерін мүліктік қорғау жөніндегі қатынастар кешенін қамтиды.',
      buttonText: 'Өтініш беру',
      infoCards: [
        {
          title: 'Сақтандыру не үшін қажет',
          content:
            'Экологиялық қауіпті қызмет түрлерін жүзеге асыру кезінде авария нәтижесінде табиғи ортаның компоненттеріне келтірілген экологиялық залалды жоюды қамтамасыз ету үшін. Бұл түр сақтандырудың міндетті түрлеріне жатады.',
        },
        {
          title: 'Дербес талаптар',
          content:
            'Қазақстан Республикасындағы міндетті экологиялық сақтандыру туралы заңнаманың талаптарына сәйкес.',
        },
        {
          title: 'Экологиялық сақтандырудың негізгі принциптері',
          content:
            'Заңнамада белгіленген көлемде және тәртіппен экологиялық залалды өтеу, залалдарды өтеу кепілдігі, тараптардың міндетті экологиялық сақтандыру шарты бойынша өз міндеттемелерін орындауын қамтамасыз ету, экологиялық залал келтіруді болғызбауды экономикалық ынталандыру.',
        },
      ],
      coverage: [
        {
          title: 'Нені сақтандырамыз',
          content: [
            'Шаруашылық және өзге де қызметтің экологиялық қауіпті түрлерін жүзеге асыратын жеке және заңды тұлғалардың жауапкершілігі.',
          ],
        },
        {
          title: 'Қандай тәуекелдерден',
          content: [
            'Авария нәтижесінде келтірілген экологиялық залалды жою (ремедиациялау) бойынша сақтанушының азаматтық-құқықтық жауапкершілігінің басталу фактісі сақтандыру жағдайы деп танылады.',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Сақтандыру сомасы',
          content:
            'Қазақстан Республикасындағы міндетті экологиялық сақтандыру туралы заңнаманың талаптарына сәйкес.',
        },
        {
          title: 'Қолданыс мерзімі',
          content: '12 ай.',
        },
        {
          title: 'Сақтандыру аумағы',
          content: 'Қазақстан Республикасы.',
        },
      ],
      formTitle: 'Өтінім қалдыру',
      formDescription: 'БСН және байланыс телефонын көрсетуді ұмытпаңыз.',
      formCheckBox1: 'Мен',
      formCheckBox2:
        'жеке деректерімді жинауға және өңдеуге келісімімді растаймын',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БСН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.пошта',
      formPlaceholder6: 'Түсініктеме',
      formButtonText: 'Жөнелту',
      formSuccessStatus: 'Сіздің өтінішіңіз сәтті жіберілді.',
      formErrorStatus: 'Өтінішті жіберу сәтсіз аяқталды.',
      formErrorMessage: 'Өтінішті 4 сағаттан кейін жіберіп көріңіз.',
      formSendClose: 'Жабу',
      trustTitle: 'Неліктен клиенттер Alatau City Garant-қа сенім артады',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 жыл',
            content: 'Қазақстанның сақтандыру нарығында қызмет еткеніне',
          },
          {
            id: 2,
            title: '3 орын',
            content:
              '2024 жылы ҚР жалпы сақтандыру компаниялары арасында сақтандыру төлемдерінің көлемі бойынша',
          },
          {
            id: 3,
            title: 'ВВ-Болжам «Тұрақты»',
            content: 'S&P Global Ratings қаржылық тұрақтылық рейтингі',
          },
          {
            id: 4,
            title: '22 филиал',
            content: 'Alatau City Garant бүкіл ел аумағында жұмыс істейді',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content:
              'сақтандыру сыйлықақыларын Alatau City Garant 2024 жылы жинады',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'Alatau City Garant 2024 жылы клиенттерге төледі',
          },
        ],
        third: '(ҚР Ұлттық Банкінің деректері бойынша)',
      },
      businessDescription:
        'Қоршаған ортаға келтірілген залал үшін міндетті жауапкершілік сақтандыруы.',
    },
  },
  ru: {
    ecology: {
      title: 'Обязательное экологическое страхование',
      description:
        'Покрывает комплекс отношений по имущественной защите интересов физ. и юр. лиц (застрахованных) при наступлении гражданско-правовой ответственности по обязательствам, возникающим вследствие причинения экологического ущерба в результате аварии.',
      buttonText: 'Отправить заявку',
      infoCards: [
        {
          title: 'Для чего нужна страховка',
          content:
            'Для обеспечения устранения экологического ущерба, причиненного компонентам природной среды в результате аварии при осуществлении экологически опасных видов деятельности. Данный вид относится к обязательным видам страхования.',
        },
        {
          title: 'Условия страхования',
          content:
            'В соответствии с требованиями законодательства об обязательном экологическом страховании в Республике Казахстан.',
        },
        {
          title: 'Основные принципы экологического страхования:',
          content:
            'Возмещение экологического ущерба в объеме и порядке, установленными законодательством, гарантия возмещения убытков, обеспечение исполнения сторонами своих обязательств по договору обязательного экологического страхования, экономическое стимулирование предотвращения причинения экологического ущерба.',
        },
      ],
      coverage: [
        {
          title: 'Что страхуем',
          content: [
            'Ответственность физических и юридических лиц, осуществляющих экологически опасные виды хозяйственной и иной деятельности.',
          ],
        },
        {
          title: 'От каких рисков',
          content: [
            'Страховым случаем признается факт наступления гражданско-правовой ответственности страхователя по устранению (ремедиации) экологического ущерба, причиненного в результате аварии.',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Страховая сумма',
          content:
            'В соответствии с требованиями законодательства об обязательном экологическом страховании  в РК.',
        },
        {
          title: 'Срок действия',
          content: '12 месяцев.',
        },
        {
          title: 'Территория страхования',
          content: 'Республика Казахстан.',
        },
      ],
      formTitle: 'Заявка на страхование',
      formDescription:
        'Пожалуйста, обязательно укажите БИН и контактный телефон.',
      formCheckBox1: 'Я подтверждаю ',
      formCheckBox2: 'согласие на сбор и обработку персональных данных',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БИН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.почта',
      formPlaceholder6: 'Комментарий',
      formButtonText: 'Отправить заявку',
      formSuccessStatus: 'Спасибо! Ваша заявка отправлена',
      formErrorStatus: 'Не удалось отправить заявку',
      formErrorMessage: 'Попробуйте отправить заявку через 4 часа.',
      formSendClose: 'Закрыть',
      trustTitle: 'Почему клиенты доверяют Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 лет',
            content: 'на страховом рынке Казахстана',
          },
          {
            id: 2,
            title: '3 место',
            content:
              'по объему страховых выплат среди компаний общего страхования РК в 2024 году',
          },
          {
            id: 3,
            title: 'ВВ-прогноз «Стабильный»',
            content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
          },
          {
            id: 4,
            title: '22 филиала',
            content: 'Alatau City Garant работают по всей стране ',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content: 'страховых премий собрал Alatau City Garant в 2024 году',
          },
          {
            id: 6,
            title: '25,5 млрд ₸',
            content: 'выплатил Alatau City Garant клиентам в 2024 году ',
          },
        ],
        third: '(по данным Нацбанка РК)',
      },
      businessDescription:
        'Обязательное страхование ответственности за причинение вреда окружающей среде.',
    },
  },

  mainCard: {
    image: MainImage,
  },
  infoCards: [
    {
      id: 1,
      image: VectorFirst,
    },
    {
      id: 2,
      image: VectirSecond,
    },
    {
      id: 3,
      image: VectorThird,
    },
  ],
  coverage: [
    {
      title: 'Что страхуем?',
      content: [
        'Ответственность физических и юридических лиц, осуществляющих экологически опасные виды хозяйственной и иной деятельности',
      ],
      image: Checkbox,
    },
    {
      title: 'От каких рисков?',
      content: [
        'Страховым случаем признается факт наступления гражданско-правовой ответственности страхователя по устранению (ремедиации) экологического ущерба, причиненного в результате аварии',
      ],
      image: Thunder,
    },
    {
      title: 'Иллюстрация',
      content: [],
      image: Contract,
    },
  ],
  featureCards: [
    {
      title: 'Страховая сумма',
      content:
        'Формируется индивидуально, в зависимости от категории риска и деятельности.',
    },
    {
      title: 'Срок действия',
      content: '1 год. Продлевается на период действия разрешений и лицензий.',
    },
    {
      title: 'Территория действия',
      content: 'Республика Казахстан.',
    },
  ],
  trustCards: {
    first: [
      {
        id: 1,
        title: '17 лет',
        content: 'на страховом рынке Казахстана',
        image: Shield,
      },
      {
        id: 2,
        title: 'ТОП 2',
        content: 'по объёму страховых выплат ',
        image: Star,
      },
      {
        id: 3,
        title: 'kzA-',
        content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
        image: Pyramid,
      },
      {
        id: 4,
        title: '600+',
        content: 'сотрудников работают по всей стране',
        image: People,
      },
    ],
    second: [
      {
        title: '59,4 млрд ₸',
        content: 'страховых премий собрано за 2024 год ',
      },
      {
        title: '22 млрд ₸',
        content: 'выплачено по страховым случаям за 2024 год',
      },
    ],
    image: Box,
  },
};

export default ecologyResources;
